module.exports = __webpack_public_path__ + "img/pernik.f90a49bd.svg";